import moment from 'moment';
import {
  INSPECAO_MT_BT_TIPO_SERVICO_ID,
  INSPECAO_USUO_MUTUO_ID,
} from '../../../../utils';
import {
  EMPTY_OPERADOR_RESUMO,
  formatMedicaoPeriodLabel,
  formatPeriodoCurto,
  getDefaultFilterDigitador,
  getMedicaoAtualPeriod,
  getPeriodoPresetRange,
  getPrimeiroNome,
  KPI_KEYS,
  matchPeriodoPreset,
  normalizeMinhaFilaFilterForApi,
  normalizeMinhaFilaResponse,
  normalizeOperadorFilterForApi,
  normalizeOperadorResumo,
  PERIODO_PRESETS,
  PERIODO_PRESET_KEYS,
  TENDENCIA_COPY,
} from '../Operador/constants';

export {
  formatMedicaoPeriodLabel,
  formatPeriodoCurto,
  getDefaultFilterDigitador,
  getMedicaoAtualPeriod,
  getPeriodoPresetRange,
  getPrimeiroNome,
  KPI_KEYS,
  matchPeriodoPreset,
  normalizeMinhaFilaFilterForApi,
  normalizeMinhaFilaResponse,
  normalizeOperadorFilterForApi,
  PERIODO_PRESETS,
  PERIODO_PRESET_KEYS,
  TENDENCIA_COPY,
};

export const LENTE_IDS = {
  MT_BT: 'MT_BT',
  USO_MUTUO: 'USO_MUTUO',
};

export const UNIDADE_LABELS = {
  servicos: 'serviços',
  postes: 'postes',
};

export const COMPARACAO_META_COPY = {
  acima: 'Acima da meta',
  abaixo: 'Abaixo da meta',
  na_media: 'Na meta',
};

export const EMPTY_LENTES = {
  lentes: [],
  defaultLenteId: null,
};

export const EMPTY_RESUMO_NOVA = {
  ...EMPTY_OPERADOR_RESUMO,
  lenteId: null,
  unidade: 'servicos',
  totalDigitado: 0,
  metaDiaria: null,
  metaPeriodo: null,
  diasUteis: null,
  diasUteisRestantes: null,
  percentualMeta: null,
  comparacaoMeta: null,
  ultimos7Dias: [],
  projecaoFimPeriodo: null,
};

export const EMPTY_ADERE = {
  mesesDisponiveis: [],
  defaultAdereMonth: null,
  selecionado: null,
};

/** Meses calendário (MM/YYYY) cruzados pelo intervalo de medição 26→25. */
export const getAdereMonthsInMedicaoPeriod = (inicio, fim) => {
  if (inicio == null || fim == null) return [];
  const months = [];
  let cursor = moment(inicio).startOf('month');
  const end = moment(fim);
  while (cursor.isSameOrBefore(end, 'month')) {
    months.push(cursor.format('MM/YYYY'));
    cursor = cursor.add(1, 'month');
  }
  return months;
};

/** Mês Adere calendário corrente (`MM/YYYY`). */
export const getCurrentAdereMonth = () => moment().format('MM/YYYY');

export const getDefaultAdereMonth = (mesesDisponiveis) => {
  if (!mesesDisponiveis?.length) return null;
  const atual = getCurrentAdereMonth();
  if (mesesDisponiveis.includes(atual)) return atual;
  return mesesDisponiveis[0];
};

/**
 * Meses Adere exibíveis: cruzados pelo ciclo 26→25, intersectados com a API,
 * ordenados DESC (mais recente primeiro).
 */
export const resolveAdereMonthsForUi = (adere, medicaoInicio, medicaoFim) => {
  const cycleMonths = getAdereMonthsInMedicaoPeriod(medicaoInicio, medicaoFim);
  if (!cycleMonths.length) return [];

  const apiMonths = adere?.mesesDisponiveis?.length
    ? adere.mesesDisponiveis
    : null;
  const filtered = apiMonths
    ? cycleMonths.filter((m) => apiMonths.includes(m))
    : cycleMonths;

  const months = (filtered.length ? filtered : cycleMonths)
    .slice()
    .sort((a, b) => {
      const [ma, ya] = a.split('/').map(Number);
      const [mb, yb] = b.split('/').map(Number);
      return (yb * 12 + mb) - (ya * 12 + ma);
    });

  return months;
};

/** Prioriza mês calendário corrente; só então default da API / mais recente. */
export const resolveDefaultAdereMonth = (adere, monthsDesc) => {
  if (!monthsDesc?.length) return null;
  const atual = getCurrentAdereMonth();
  if (monthsDesc.includes(atual)) return atual;
  const apiDefault = adere?.defaultAdereMonth;
  if (apiDefault && monthsDesc.includes(apiDefault)) return apiDefault;
  return monthsDesc[0];
};

export const normalizeLentesResponse = (data) => {
  if (!data || typeof data !== 'object') {
    return { ...EMPTY_LENTES };
  }
  const lentes = Array.isArray(data.lentes) ? data.lentes : [];
  return {
    lentes: lentes.filter((l) => l?.id && l?.ativo !== false),
    defaultLenteId: data.defaultLenteId ?? lentes[0]?.id ?? null,
  };
};

const normalizeAdereSelecionado = (sel) => {
  if (!sel || typeof sel !== 'object') return null;
  return {
    adereMonth: sel.adereMonth ?? null,
    janelaInicio: sel.janelaInicio ?? null,
    janelaFim: sel.janelaFim ?? null,
    servicosDigitados: sel.servicosDigitados
      ?? sel.servicosDigitadosNoMesAdere
      ?? 0,
    nsirsNaFila: sel.nsirsNaFila
      ?? sel.nsirsAdereNaFila
      ?? 0,
    nsirsFechadas: sel.nsirsFechadas ?? 0,
    nsirsEmInspecao: sel.nsirsEmInspecao ?? 0,
    servicosPendentes: sel.servicosPendentes
      ?? sel.servicosPendentesAdere
      ?? 0,
    servicosPendentesEmAberto: sel.servicosPendentesEmAberto
      ?? sel.servicosPendentes
      ?? sel.servicosPendentesAdere
      ?? 0,
    diasUteisRestantesAdere: sel.diasUteisRestantesAdere ?? null,
    diasUteisDecorridosAdere: sel.diasUteisDecorridosAdere ?? null,
    ritmoAdere: sel.ritmoAdere ?? null,
    ritmoNecessario: sel.ritmoNecessario ?? null,
    diasNecessarios: sel.diasNecessarios ?? null,
    fechaNoPrazo: sel.fechaNoPrazo ?? null,
    dataEstimadaFim: sel.dataEstimadaFim ?? null,
    digitadosForaJanela: sel.digitadosForaJanela ?? 0,
  };
};

/** Response de `POST /reports/digitacao/me/adere` (raiz = antigo bloco adere do resumo). */
export const normalizeAdereResponse = (data) => {
  if (!data || typeof data !== 'object') {
    return { ...EMPTY_ADERE };
  }
  return {
    mesesDisponiveis: data.mesesDisponiveis ?? [],
    defaultAdereMonth: data.defaultAdereMonth ?? null,
    selecionado: normalizeAdereSelecionado(data.selecionado),
  };
};

export const normalizeResumoNova = (data) => {
  const base = normalizeOperadorResumo(data);
  if (!data || typeof data !== 'object') {
    return { ...EMPTY_RESUMO_NOVA };
  }

  /** Série factual dos últimos 7 dias (mais antigo → hoje). Fallback legado: tendencia7dias. */
  const ultimos7Dias = data.ultimos7Dias
    ?? data.tendencia7dias
    ?? data.meuPeriodo?.ultimos7Dias
    ?? data.meuPeriodo?.tendencia7dias
    ?? [];

  return {
    ...base,
    lenteId: data.lenteId ?? null,
    unidade: data.unidade ?? 'servicos',
    totalDigitado: data.totalDigitado ?? base.servicosDigitados,
    metaDiaria: data.metaDiaria ?? null,
    metaPeriodo: data.metaPeriodo ?? base.meuPeriodo?.metaPeriodo ?? null,
    diasUteis: data.diasUteis ?? null,
    diasUteisRestantes: data.diasUteisRestantes ?? null,
    percentualMeta: data.percentualMeta ?? null,
    comparacaoMeta: data.comparacaoMeta ?? base.meuPeriodo?.comparacaoMedia ?? null,
    ultimos7Dias,
    projecaoFimPeriodo: data.projecaoFimPeriodo ?? null,
    meuPeriodo: {
      ...base.meuPeriodo,
      metaPeriodo: data.metaPeriodo ?? base.meuPeriodo?.metaPeriodo ?? null,
      ultimos7Dias,
      comparacaoMedia: data.comparacaoMeta ?? base.meuPeriodo?.comparacaoMedia ?? 'na_media',
    },
  };
};

export const getVolumeLabel = (lente) => {
  if (lente?.unidade === 'postes' || lente?.id === LENTE_IDS.USO_MUTUO) {
    return 'Postes digitados';
  }
  return 'Serviços digitados';
};

export const formatHeroLenteResumo = (resumo, lente) => {
  if (!resumo || !lente) return '';
  const total = resumo.totalDigitado ?? resumo.servicosDigitados ?? 0;
  const meta = resumo.metaPeriodo ?? resumo.meuPeriodo?.metaPeriodo;
  const media = resumo.mediaDiaUtil ?? 0;
  const unidade = lente.unidade === 'postes' ? ' postes' : '';
  const metaStr = meta != null ? `/${meta}${unidade}` : '';
  const mediaStr = media ? ` (${Math.round(media * 10) / 10}/dia)` : '';
  return `${total}${metaStr}${mediaStr}`;
};

/** Resumo do ciclo — sem `adereMonth` (Adere vive em `/me/adere`). */
export const buildResumoFilter = (filter, authData, lenteId) => {
  const body = normalizeOperadorFilterForApi(filter, authData);
  if (lenteId) body.lenteId = lenteId;
  return body;
};

/**
 * Body enxuto de `POST /reports/digitacao/me/adere`.
 * Sem período/geo — servidor resolve ciclo 26→25 e escopo do digitador.
 * `adereMonth` sempre enviado — default = mês calendário corrente.
 * DIGITADOR: backend ignora/força JWT; front ainda envia `digitadorIds: [eu]`.
 * ADMIN: backend aceita `digitadorIds` do body.
 */
export const buildAdereFilter = (authData, lente, adereMonth) => {
  const body = {
    lenteId: LENTE_IDS.MT_BT,
    tipoServicos: Array.isArray(lente?.tipoServicoIds) ? lente.tipoServicoIds : [],
    adereMonth: adereMonth || getCurrentAdereMonth(),
  };
  if (authData?.id) {
    body.digitadorIds = [authData.id];
  }
  return body;
};

/** Histórico: período + lente — sem adereMonth. */
export const buildHistoricoFilter = (filter, authData, lenteId) =>
  buildResumoFilter(filter, authData, lenteId);

export const isLenteMtBt = (lenteId) => lenteId === LENTE_IDS.MT_BT;

export const isLenteUsoMutuo = (lenteId) => lenteId === LENTE_IDS.USO_MUTUO;

export const getHistoricoEmptyMessage = (lente) => {
  if (lente?.label) {
    return `Nenhuma digitação ${lente.label} neste período.`;
  }
  return 'Nada neste período — serviços digitados no intervalo aparecem aqui.';
};

export const getHistoricoVolumeUnit = (lente) => (
  lente?.unidade === 'postes' || lente?.id === LENTE_IDS.USO_MUTUO ? 'postes' : 'servicos'
);

export const EXPORT_TIPO_SERVICO_OPTIONS = [
  { value: INSPECAO_MT_BT_TIPO_SERVICO_ID, label: 'Inspeção MT/BT' },
  { value: INSPECAO_USUO_MUTUO_ID, label: 'Inspeção Uso Mútuo' },
];

export const getDefaultExportFilter = (authData) => {
  const { inicio, fim } = getMedicaoAtualPeriod();
  return {
    inicio,
    fim,
    dateTypes: ['DATA_DIGITACAO'],
    digitadorId: authData?.id ? [authData.id] : [],
  };
};

/**
 * Body de `POST /reports/digitacao/daily` — contrato servidor (singular malhaId, digitadorId).
 * Não reutiliza normalizeFilterForApi do relatório (plural digitadorIds/malhaIds + default MT/BT).
 */
export const normalizeExportFilterForApi = (filter, authData) => {
  if (!filter || typeof filter !== 'object') return {};
  const body = {};

  if (filter.inicio != null) body.inicio = filter.inicio;
  if (filter.fim != null) body.fim = filter.fim;
  if (filter.codigo) body.codigo = filter.codigo;

  const toArray = (v) => {
    if (Array.isArray(v)) return v.filter((item) => item != null && item !== '');
    if (v != null && v !== '') return [v];
    return [];
  };

  const digitadorId = toArray(filter.digitadorId).length > 0
    ? toArray(filter.digitadorId)
    : (authData?.id ? [authData.id] : []);
  if (digitadorId.length > 0) body.digitadorId = digitadorId;

  if (Array.isArray(filter.tipoServicos) && filter.tipoServicos.length > 0) {
    body.tipoServicos = filter.tipoServicos;
  }

  if (Array.isArray(filter.subTipoIds) && filter.subTipoIds.length > 0) {
    body.subTipoIds = filter.subTipoIds;
  }

  if (Array.isArray(filter.clienteIds) && filter.clienteIds.length > 0) {
    body.clienteIds = filter.clienteIds;
  }

  if (Array.isArray(filter.statuses) && filter.statuses.length > 0) {
    body.statuses = filter.statuses;
  }

  if (filter.malhaId != null && filter.malhaId !== '') {
    body.malhaId = Array.isArray(filter.malhaId) ? filter.malhaId[0] : filter.malhaId;
  }

  if (filter.gerenciaId) body.gerenciaId = filter.gerenciaId;
  if (filter.poloId) body.poloId = filter.poloId;
  if (filter.subestacaoId) body.subestacaoId = filter.subestacaoId;
  if (filter.alimentadorId) body.alimentadorId = filter.alimentadorId;

  return body;
};
